import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {useParams} from "react-router-dom";
import {observer} from "mobx-react";
import {courseApi} from "../api/courseApi";
import {teacherApi} from "../api/teacherApi";
import {Menu} from "../menu/menu";
import {MeetingRecordingsList} from "../courses/meetingRecordingsList";
import homeStyle from '../main/home.scss';
import style from './teacherMediaRecordings.scss';

export const TeacherMediaRecordings = observer(function TeacherMediaRecordings() {
  const {teacherId} = useParams();
  const [teacher, setTeacher] = useState({});
  const [meetings, setMeetings] = useState(null);

  useEffect(() => {
    (async () => {
      setTeacher(await teacherApi.getTeacher(teacherId));

      const recentTeacherMeetings = await courseApi.searchMeetingsByTeacherIdAndPeriod(
        teacherId,
        moment().subtract(21, 'days'),
        moment()
      );
      setMeetings([...recentTeacherMeetings].sort((a, b) => moment(b.startTime).valueOf() - moment(a.startTime).valueOf()));
    })();
  }, [teacherId]);

  return (
    <div className={homeStyle.home}>
      <Menu/>
      <div className={homeStyle.list}>
        <div className={style.header}>Media recordings for {teacher.name}</div>
        <MeetingRecordingsList meetings={meetings} emptyMessage="No meetings found for this teacher recently"/>
      </div>
    </div>
  );
});